export default "__VITE_ASSET__sI8Le$y4__"